import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Get } from "libs/services";
import { ITEM, STORES } from "libs/config";
import { StoresResponse } from "src/common/types/response/allStores";
import { BaseResponse } from "src/common/types/response/BasePaginationResponse";
import {
  PopularItemResponse,
  StoreItemResponse,
} from "src/common/types/response/storeItems";

interface ItemsState {
  items: Array<any>;
  loading: boolean;
}

export const getStoreAndItems = createAsyncThunk(
  "item/getStoreAndItems",
  async (params: {}, thunkAPI) => {
    try {
      const query = { ...params };
      const itemPromise = Get<BaseResponse<PopularItemResponse>>(
        ITEM.get,
        query
      );
      // const storePromise = Get<BaseResponse<StoresResponse>>(STORES.get, query);
      const [
        item,
        // store
      ] = await Promise.allSettled([
        itemPromise,
        // storePromise,
      ]);

      return {
        itemResponse:
          item.status === "fulfilled" ? item.value.data.payload : [],
        storeResponse: [],
        itemMeta: item.status === "fulfilled" ? item.value.data.meta : {},
        // store.status === "fulfilled" ? store.value.data.payload : [],
      };
    } catch (error) {
      return null;
    } finally {
      // thunkAPI.dispatch(setLoading(false));
    }
  }
);

export const getItems = createAsyncThunk(
  "item/getItems",
  async (query: {}, thunkAPI) => {
    try {
      const response = await Get<StoreItemResponse>(ITEM.get, query);
      return response.data.payload;
    } catch (error) {
      throw error;
    } finally {
    }
  }
);

export const getItemByUPC = (upc)=> Get<StoreItemResponse>(`${ITEM.imageUpc}/${upc}`);

const initialState: ItemsState = {
  items: [],
  loading: false,
};

export const itemSlice = createSlice({
  name: "items",
  initialState,
  reducers: {
    clearData: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getItems.pending, (state, action) => {
      state.loading = true;
      state.items = null;
    });
    builder.addCase(getItems.fulfilled, (state, action) => {
      state.items = action.payload;
      state.loading = false;
    });
    builder.addCase(getItems.rejected, (state, action) => {
      state.items = null;
      state.loading = false;
    });
  },
});

export const { clearData } = itemSlice.actions;

export default itemSlice.reducer;
